//
import React, { Component } from "react"

import { datePickerGenericFilter, textGenericFilter, enumValueSort } from "shared/search/containers/Filter/Filters"
import { enumGenericFilter, searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import { isValidAmountStringNegative } from "shared/imports/sharedHelperFunctions"
import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"
import { PoliticalCommitteeCampaignFinanceFilterableListView } from "shared/search/containers/FilterableListView/FilterableListViews"
import { PoliticalCommitteeCampaignFinanceSelect } from "app/static/frontend/selects/containers/PieSelect"

export class DisbursementsTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "disburserType",
        filterKey: "disburserTypes",
        enumItems: [
            {
                fa5_icon: "minus",
                key: "refund_given",
                label: "Presidential committees",
                pac_label: "Presidential committees",
                value: "presidential",
            },
            {
                fa5_icon: "minus",
                key: "refund_given",
                label: "Senate committees",
                pac_label: "Senate committees",
                value: "senate",
            },
            {
                fa5_icon: "minus",
                key: "house",
                label: "House committees",
                pac_label: "House committees",
                value: "house",
            },
            {
                fa5_icon: "minus",
                key: "pac",
                label: "PACs",
                pac_label: "PACs",
                value: "pac",
            },
            {
                fa5_icon: "minus",
                key: "party",
                label: "Party committees",
                pac_label: "Party committees",
                value: "party",
            },
        ],
        displayKey: "pac_label",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsRecipientTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "recipientType",
        filterKey: "recipientTypes",
        enumItems: [
            {
                fa5_icon: "minus",
                key: "presidential",
                label: "Presidential committees",
                pac_label: "Presidential committees",
                value: "presidential",
            },
            {
                fa5_icon: "minus",
                key: "presidential",
                label: "Senate committees",
                pac_label: "Senate committees",
                value: "senate",
            },
            {
                fa5_icon: "minus",
                key: "house",
                label: "House committees",
                pac_label: "House committees",
                value: "house",
            },
            {
                fa5_icon: "minus",
                key: "party",
                label: "Party committees",
                pac_label: "Party committees",
                value: "party",
            },
            {
                fa5_icon: "minus",
                key: "pac",
                label: "PACs",
                pac_label: "PACs",
                value: "pac",
            },
            {
                fa5_icon: "minus",
                key: "super_pac",
                label: "Super PACs",
                pac_label: "Super PACs",
                value: "super_pac",
            },
            {
                fa5_icon: "minus",
                key: "leadership_pac",
                label: "Leadership PACs",
                pac_label: "Leadership PACs",
                value: "leadership_pac",
            },
            {
                fa5_icon: "minus",
                key: "joint_fundraising_committee",
                label: "Joint Fundraising Committees (JFCs)",
                pac_label: "Joint Fundraising Committees (JFCs)",
                value: "joint_fundraising_committee",
            },
            {
                fa5_icon: "minus",
                key: "527_org",
                label: "527 Orgs",
                pac_label: "527 Orgs",
                value: "527_org",
            },
            {
                fa5_icon: "minus",
                key: "other",
                label: "Other",
                pac_label: "Other",
                value: "other",
            },
        ],
        displayKey: "pac_label",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "disbursementsDateStart",
        filterKey: "dateStart",
        displayLabel: "Date From",
        helpText: "Disbursements start date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "disbursementsDateEnd",
        filterKey: "dateEnd",
        displayLabel: "Date To",
        helpText: "Disbursements end date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsAmountMinFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "disbursementsAmountMinEnd",
        filterKey: "amountMin",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        validateTextInput: isValidAmountStringNegative,
        displayLabel: "Amount min",
        helpText: "Disbursements amount min.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsAmountMaxFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "disbursementsAmountMaxEnd",
        filterKey: "amountMax",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        displayLabel: "Amount max",
        validateTextInput: isValidAmountStringNegative,
        helpText: "Disbursements amount max.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsDisburserFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "disbursementsDisburserFilter",
            filterKey: "political_committee_disbursements_cf",
            dataTypeLabel: "Disbursement",
            searchifyFLV: PoliticalCommitteeCampaignFinanceFilterableListView,
            selectComponent: PoliticalCommitteeCampaignFinanceSelect,
            displayLabel: "Political Committees",
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class DisbursementsPoliticalCommitteeFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "politicalCommitteeFilter",
            filterKey: "political_committee_receipts_cf",
            dataTypeLabel: "POLITICALCOMMITTEE",
            displayLabel: "Political Committees",
            searchifyFLV: PoliticalCommitteeCampaignFinanceFilterableListView,
            selectComponent: PoliticalCommitteeCampaignFinanceSelect,
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
